<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              :items="typeItems"
              item-text="title"
              item-value="value"
              v-model="type"
              placeholder="Loại giao dịch"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              :items="[
                {title: 'Chưa thanh toán', value: 'pending'},
                {title: 'Đã thanh toán', value: 'success'},
                {title: 'Đã huỷ', value: 'canceled'},
              ]"
              item-text="title"
              item-value="value"
              v-model="status"
              placeholder="Trạng thái"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-mask="'##/##/####'"
              placeholder="Ghi nhận vào ngày"
              name="login"
              v-model="transactionTime"
              type="text"
              color="primary"
              flat
              outlined
              dense
              validate-on-blur
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="2">
        <v-btn color="admin" height="40px" width="100%" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row class="my-0">
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-model="transactionCode"
              v-if="advancedFilter"
              placeholder="Mã tài khoản"
              clearable
              flat
              outlined
              dense
            />
          </v-col>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-model="transactionId"
              v-if="advancedFilter"
              placeholder="Mã tham chiếu giao dịch"
              clearable
              flat
              outlined
              dense
            />
          </v-col>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-model="userPhone"
              v-if="advancedFilter"
              placeholder="Tài khoản tạo"
              clearable
              flat
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="2" class="py-6">
        <v-btn color="admin" height="40px" width="100%" @click="advancedFilter = !advancedFilter" text>
          Nâng cao <v-icon v-if="!advancedFilter">mdi-chevron-down</v-icon><v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import {TYPES} from './helpers'
export default {
  data: () => ({
    advancedFilter: false,
    type: '',
    typeItems: TYPES,
    status: '',
    transactionTime: '',
    transactionCode: '',
    transactionId: '',
    userPhone: '',
  }),
  methods: {
    onFilterChanged() {
      let query = {
        type: this.type,
        status: this.status,
        transactionCode: this.transactionCode,
        transactionId: this.transactionId,
        userPhone: this.userPhone,
        transactionTime: this.transactionTime,
      }
      this.$emit('onFilterChanged', query)
    },
  },
}
</script>
